export default __webpack_public_path__ + "static/media/uploader-roche-problem-1.77292b71.png";